import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const TrocaSenha = () => {
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const isPrimeiroAcesso = user?.primeiro_acesso;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.newPassword.length < 6) {
      return setError('A nova senha deve ter pelo menos 6 caracteres.');
    }
    if (form.newPassword !== form.confirmPassword) {
      return setError('A nova senha e a confirmação não coincidem.');
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });

      updateUser({ primeiro_acesso: false });
      navigate('/catalogo', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao alterar senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black px-4">
      <div className="mb-10">
        <img src="/logo-branca.png" alt="Simmons Grupo Yasin" className="h-12 w-auto" />
      </div>

      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-lg font-semibold text-gray-800 mb-1">
            {isPrimeiroAcesso ? 'Defina sua senha' : 'Alterar senha'}
          </h2>
          {isPrimeiroAcesso && (
            <p className="text-sm text-gray-500 mb-6">
              Este é seu primeiro acesso. Crie uma senha para continuar.
            </p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4 mt-4" noValidate>
            {!isPrimeiroAcesso && (
              <div>
                <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700 mb-1">
                  Senha atual
                </label>
                <input
                  id="currentPassword"
                  name="currentPassword"
                  type="password"
                  required
                  value={form.currentPassword}
                  onChange={handleChange}
                  className="input"
                  placeholder="••••••••"
                />
              </div>
            )}

            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-1">
                Nova senha
              </label>
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                required
                value={form.newPassword}
                onChange={handleChange}
                className="input"
                placeholder="Mínimo 6 caracteres"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                Confirmar nova senha
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                value={form.confirmPassword}
                onChange={handleChange}
                className="input"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <p className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg" role="alert">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-2.5 mt-2"
            >
              {loading ? 'Salvando...' : 'Salvar senha'}
            </button>
          </form>
        </div>
      </div>

      <p className="mt-8 text-xs text-white/20">
        © {new Date().getFullYear()} Simmons Grupo Yasin
      </p>
    </div>
  );
};

export default TrocaSenha;
